import { Component, HostListener, AfterViewInit, inject } from "@angular/core";
import { ScreenResizeService } from "src/utils/screen-resize.service";

@Component({
  selector: "app-screen-size-detector",
  templateUrl: "./screen-size-detector.component.html",
  styleUrls: ["./screen-size-detector.component.scss"],
})
export class ScreenSizeDetectorComponent implements AfterViewInit {
  private resizeSvc = inject(ScreenResizeService);

  @HostListener("window:resize", ["$event"])
  onResize($event: any) {
    this.detectScreenSize($event);
  }

  ngAfterViewInit() {
    const payload = {
      target: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      },
    };
    this.detectScreenSize(payload);
  }

  detectScreenSize($event: any) {
    const payload = {
      width: $event.target.innerWidth,
      height: $event.target.innerHeight,
    };
    this.resizeSvc.onResize(payload);
  }
}
